__turbopack_context__.v({
  "container": "CompanyDeckSection-module-scss-module__EqDc9G__container",
  "contentCard": "CompanyDeckSection-module-scss-module__EqDc9G__contentCard",
  "downloadLink": "CompanyDeckSection-module-scss-module__EqDc9G__downloadLink",
  "image": "CompanyDeckSection-module-scss-module__EqDc9G__image",
  "imageCard": "CompanyDeckSection-module-scss-module__EqDc9G__imageCard",
});
